// extracted by mini-css-extract-plugin
export default {"helpModal":"PopupSuccessError_helpModal__I3ABa","sangria":"PopupSuccessError_sangria__KqIsC","buttonCancel":"PopupSuccessError_buttonCancel__+0ZOH"};